export const USER_FILTER_TYPE = {
  All: 1,
  User: 2,
  InviteUser: 3
};


export const FROM_PAGE = {
  PMS_CONFIG: 'PMS Configuration',
  ASSESSMENT: 'Assessment'
}

export const USER_TYPE =
{
    PracticeUser: 1,
    ChainUser: 2,
}

export const MEMBER_PRACTICE_STATUS =
{
    Invited: 1,
    Active: 2,
    Expired: 3,
    Deleted: 4,
}